  import request from "./request";

const AssessmentService = {
  
  GetAllQuestions: async (topicId, context) => {
    return await request.sendRequest(
      `/assessment/all/${topicId}`,
      context?.token
    );
  },

  GetAllExamQuestions: async (topicId, context) => {
    return await request.sendRequest(
      `/assessment/exam/all/${topicId}`,
      context?.token
    );
  },

   GetAssessmentSessions: async (topicId, searchText, context) => {
  const url = searchText
    ? `/assessment/exam/sessions/${topicId}/${searchText}`
    : `/assessment/exam/sessions/${topicId}`;

  return await request.sendRequest(url, context?.token);
 },

GetAssessmentAttendees: async (take, skip, topicId, searchText, context) => {
  const url = searchText
    ? `/assessment/exam/attendees/${take}/${skip}/${topicId}/${searchText}`
    : `/assessment/exam/attendees/${take}/${skip}/${topicId}`;

  return await request.sendRequest(url, context?.token);
},


  PostQuestion: async (payload, context) => {
    return await request.sendPostRequest(
      "/assessment",
      payload,
      context
    );
  },

  PostBulkQuestions: async (payload, context) => {
    return await request.sendPostRequest(
      "/assessment/bulk",
      payload,
      context
    );
  },

  ImportQuestions: async (topicId, payload, context) => {
    return await request.sendFormDataRequest(
      `/assessment/import/${topicId}`,
      payload,
      context
    );
  },

  DeleteAssessment: async (id, context) => {
    return await request.sendDeleteRequest(
      `/assessment/${id}`,
      context?.token
    );
  },

  RemoveQuestions: async (id, context) => {
    return await request.sendDeleteRequest(
      `/assessment/questions/${id}`,
      context?.token
    );
  },

  SaveAssessmentExam: async (payload, context) => {
    return await request.sendPostRequest(
      "/assessment/exam",
      payload,
      context
    );
  },

  StartExam: async (topicId, context) => {
    return await request.sendPutRequest(
      `/assessment/exam/start/${topicId}`,
      context
    );
  },

  CancelExam: async (payload, context) => {
    return await request.sendPostRequest(
      "/assessment/exam/cancel",
      payload,
      context
    );
  },

  RemoveExam: async (id, context) => {
    return await request.sendDeleteRequest(
      `/assessment/exam/${id}`,
      context?.token
    );
  },

  RemoveExamSession: async (topicId, userId, context) => {
    return await request.sendDeleteRequest(
      `/assessment/exam/session/${topicId}/${userId}`,
      context?.token
    );
  },

  RecalculateExamScores: async (topicId, context) => {
    return await request.sendPutRequest(
      `/assessment/exam/calculate/${topicId}`,
      context
    );
  },

  RecalculateScore: async (examId, context) => {
    return await request.sendPutRequest(
      `/assessment/exam/re-calculate/${examId}`,
      context
    );
  },
}
export default AssessmentService;
